module.exports = __webpack_public_path__ + "img/init.07b788fc.png";